import { getHowToBuyProductController } from '../../api/controllers/buyWithInstacredController';
import { howToBuyProductActionType } from '../../actionTypes';

export default (payload) => (dispatch) => {
  const { campaignId, lenderId, handle, productId } = payload || {};
  const data = {
    campaignId,
    merchantHandle: handle,
    lenderId,
    productId,
  };
  dispatch({
    type: howToBuyProductActionType.GET_HOW_TO_BUY_PRODUCT_REQUEST,
    payload: { handle, productId },
  });
  return getHowToBuyProductController(data)
    .then((resp) => {
      const { howToBuy, merchantMetadata, banners } = resp.data || {};
      const {
        merchantLogo,
        title,
        desktopImgUrl,
        actionUrl,
        videoUrl,
        offers,
      } = howToBuy || {};
      const { id, name, description, logoUrl } = merchantMetadata || {};
      const data = {
        handle,
        merchantLogo,
        howToBuyTitle: title,
        howToBuyImage: desktopImgUrl,
        merchantUrl: actionUrl,
        videoUrl,
        merchantId: id,
        merchantName: name,
        htbBanners: banners,
        description,
        logoUrl,
        offers,
        productId,
      };
      dispatch({
        type: howToBuyProductActionType.GET_HOW_TO_BUY_PRODUCT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: howToBuyProductActionType.GET_HOW_TO_BUY_PRODUCT_ERROR,
        payload: { handle, productId, error },
      });
    });
};



// WEBPACK FOOTER //
// ./actions/howToBuyProductActions/fetchHowTobuyProductDetails.js